module.exports = __webpack_public_path__ + "static/Abdul Karim-f6722ededf4e446713bf13cd52d0fb96.jpg";